module.exports = __webpack_public_path__ + "img/woman-body-upper-front.425a1254.png";